import fetch from 'utils/fetch';

export function registerAgent(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/registerAgent',
        method: 'post',
        data
    });
}

export function agentList(account,remark,psize) {
    const data = {
        account,
        remark,
        psize
    };
    return fetch({
        url: '/agentList',
        method: 'get',
        params:data
    });
}

export function upAgent(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/upAgent',
        method: 'put',
        data
    });
}

export function agentRecharge(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/agentRecharge',
        method: 'post',
        data
    });
}

export function batchDelAgent(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/batchDelAgent',
        method: 'post',
        data
    });
}

export function editAgentPassword(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/editAgentPassword',
        method: 'post',
        data
    });
}



// WEBPACK FOOTER //
// ./src/api/agent.js